var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "24px",
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tablet_mac") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-817.000000, -2502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hardware",
    transform: "translate(100.000000, 2404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Hardware-/-tablet_mac",
    transform: "translate(714.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-133",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,0 L5.5,0 C4.12,0 3,1.12 3,2.5 L3,21.5 C3,22.88 4.12,24 5.5,24 L19.5,24 C20.88,24 22,22.88 22,21.5 L22,2.5 C22,1.12 20.88,0 19.5,0 Z M12.5,23 C11.67,23 11,22.33 11,21.5 C11,20.67 11.67,20 12.5,20 C13.33,20 14,20.67 14,21.5 C14,22.33 13.33,23 12.5,23 Z M20,19 L5,19 L5,3 L20,3 L20,19 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#1D1D1D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.4253bd4f8a4c78223cf287956dbed358.svg";
export { ForwardRef as ReactComponent };